<template>
    <div class="full-width" ref="record7EditorDom" v-loading="loading">
        <div v-show="viewTag == 'show'">
            <h4 tkey="名片展示公司通訊">{{i18n.tkey("lang_wrok_show_commpany_tpye")}}</h4>

            <div class="open-other-div" v-show="viewTag == 'show'">
                <div class="method-box">
<!--                  <div class="icon-style">
                    <img class="icon-img" @click="viewTag = 'eshopopee'" :src="`${staticPath}static/images/icon_e-shopopee_logo.png`" >
                  </div>-->
                    <div class="icon-style" v-for="(v, i) in recordList" :key="v.id">
                        <img class="icon-img" @click="goEdit(v)" :src="`${shopopeeUrl}${v.addinfo2}?r=${Math.random()}`" >
                        <span class="del-span" @click="delRecord7(v)"><font-awesome-icon icon="fa-solid fa-xmark" /></span>
                    </div>

                    <div class="icon-style" @click="goAdd">
                        <img class="icon-img" :src="`${staticPath}static/images/icon_btn_add.jpg`" >
                    </div>
                </div>
            </div>
        </div>


        <div v-if="viewTag == 'edit' || viewTag == 'add'">
            <h4 v-show="viewTag == 'add'" tkey="添加通訊方式">{{i18n.tkey("lang_add_contact_method_1")}}</h4>
            <h4 v-show="viewTag == 'edit'" tkey="修改通訊方式">{{i18n.tkey("lang_edit_contact_method_1")}}</h4>

            <div style="text-align: left; margin-bottom: 10px">
                <el-button @click="returnShow" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <addOrUpdateRecord7 :editCard="editCard" :editObj="editObj" :isCompany="true"  @operateComplete="returnShow" />
        </div>
      <div v-if="viewTag == 'eshopopee'">
        <h4 tkey="設置eshopopee">{{i18n.tkey("lang_setting")}}eshopopee</h4>

        <div style="text-align: left; margin-bottom: 10px">
          <el-button @click="returnShow" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
        </div>
        <div class="full-width-flex info-div">
          <div>
            <span tkey="顯示/隱藏">{{i18n.tkey("lang_show_hide")}}:</span>&nbsp;&nbsp; <el-select style="width: 100px" v-model="eshopopeeeys">
            <el-option
                :key="11"
                :label="i18n.tkey('lang_show')"
                :value="0"
            />

            <el-option
                :key="22"
                :label="i18n.tkey('lang_hide')"
                :value="-1"
            />
          </el-select>
          </div>

          <div style="text-align: center;">
            <el-button type="primary" @click="updateCompanyInfo" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
          </div>

        </div>
      </div>

    </div>
</template>

<script setup>
    //組件寬度
    import {getCurrentInstance, inject, onMounted, provide, ref, toRef} from "vue";
    import addOrUpdateRecord7 from "@/components/shopopee/record7/addOrUpdateRecord7"
    import cardApi from "@/request/api";
    import memberWorkApi from "@/request/memberWorkApi";
    import record7Api from "@/request/record7Api";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faXmark } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";
    import { useCompanyinfo } from '@/stores/companyinfo'
    import companyApi from "@/request/companyApi";

    library.add(faXmark)

    const staticPath = process.env.BASE_URL

    const { proxy } = getCurrentInstance();
    const shopopeeUrl = proxy.$ShopopeeUrl

    //const { getCurrCard } = inject('myCardViewFunc', { getCurrCard: () => { return null } })

    const width = ref(425)

    const i18n = inject("i18n")

    const viewTag = ref("show")
    const recordList = ref([])
    const editCard = ref(null)
    const editObj = ref(null)

    const loading = ref(false)

    const eshopopeeeys = ref(0)
    const companyInfoRef = toRef(useCompanyinfo())

    function getRecord7List(){
        const card = editCard.value

        if (null == card){
            return
        }

        if (null == card.inputby){
            return;
        }

        const request = record7Api.getAdditionalrecord7List
        const param = request.getParams()

        param.group = card.inputby.split(",")

        request.send(param, (res) => {
            if (res.code == 200){
                recordList.value = res.detail
            }
        })
    }

    function getCurrCard(){
      const request = memberWorkApi.queryCompanyDefaultMemberWork
      const param = request.getParams()

      param.companycode = companyInfoRef.value.companycode

      request.send(param, (res) => {
        if (res.code == 200){
          editCard.value = res.detail
          getRecord7List()
        }
      })

    }
    function updateCompanyInfo(){

      const request = companyApi.updateCompany
      const params = request.getParams()
      params.dinumber = eshopopeeeys.value
      params.companycode = companyInfoRef.value.companycode
      params.id = companyInfoRef.value.id

      request.send(params, function (){

      })
    }



    provide('myCompanyViewFunc', {
      updateInputBy,
    })
    function updateInputBy(inputby){
      editCard.value.inputby = inputby

    }
    function goAdd(){
        editObj.value = null
        viewTag.value = "add"
    }

    function goEdit(obj){
        editObj.value = obj
        viewTag.value = "edit"
    }

    function returnShow(){
        getRecord7List()
        viewTag.value = 'show'
    }

    function delRecord7(obj){
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            loading.value = true

            let addinfo1Array = editCard.value.inputby.split(",")
            let addinfo1Str = ""

            for (let i=0; i<addinfo1Array.length; i++){
                const s = addinfo1Array[i]

                if (obj.id == s){
                    continue;
                }

                addinfo1Str += `${s},`
            }

            const request = record7Api.deleteAdditionalrecord7
            const params = request.getParams()

            params.id = obj.id
            request.send(params, (res) => {

            })

            const request2 = memberWorkApi.updateMemberWorkByInputBy
            const params2 = request2.getParams()

            params2.companycode = editCard.value.companycode
            params2.inputby = addinfo1Str

            request2.send(params2, (res) => {
                loading.value = false

                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
                  getCurrCard()
                }
            })
        })
    }

    onMounted(() => {
        width.value = proxy.$refs.record7EditorDom.offsetWidth
        if(companyInfoRef.value!=null&&myUtil.isNotEmpty(companyInfoRef.value.dinumber)){

          eshopopeeeys.value =companyInfoRef.value.dinumber
        }
        getCurrCard()
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .open-other-div {
        margin: 0 auto;
        max-width: 500px;
        text-align: center;
        margin-bottom: 0;
        margin-top: 0;
        padding: 10px;
    }

    .open-other-div .method-box {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
    }

    .open-other-div .icon-style {
        padding: 12px;
        position: relative;
        float: left;
        width: 20%;
        padding-top: 20%;
        transition: 1s all ease;
    }

    .open-other-div .icon-style:hover {
        transform: scale(1.1);
    }

    .icon-img {
        position: absolute;
        left: 10px;
        top: 10px;
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        border-radius: 10px;
    }

    .del-span {
        position: absolute;
        top: 10px;
        right: 5px;
        width: 25px;
        height: 25px;
        color: red;
        font-size: 18px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 0.5);
        text-align: center;
        line-height: 25px;
    }
</style>